import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import InlineDatePicker from './components/InlineDatePicker';
import MobileReservationFlow from './components/MobileReservationFlow';
import RoiCalculator from './components/RoiCalculator';
import GroupBuyBanner from './components/GroupBuyBanner';
import UserButtons from './components/UserButtons';
import { ClerkProvider } from '@clerk/clerk-react';

import { MantineProvider, ColorSchemeScript } from '@mantine/core';

import Portal from './portals/Portal';

import DatepickerAppContainer from './DatepickerAppContainer';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';

type Props = {
  module: string;
};

// Import your publishable key
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key');
}
// Create a client
const queryClient = new QueryClient();

function App({ module }: Props) {
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY as string} afterSignOutUrl="/">
      <QueryClientProvider client={queryClient}>
        <ColorSchemeScript forceColorScheme="light" />
        <MantineProvider
          forceColorScheme="light"
          theme={{
            fontFamily: 'Satoshi, sans-serif'
            // fontFamilyMonospace: 'Monaco, Courier, monospace',
            // headings: { fontFamily: 'Greycliff CF, sans-serif' },
          }}>
          <Portal container="datepicker-app">
            <DatepickerAppContainer>
              <Portal container="inline-datepicker-widget">
                <InlineDatePicker
                  columns={2}
                  numCalendars={2}
                  showPriceDetails={false}
                  showBookButton={false}
                />
              </Portal>
              <Portal container="inline-datepicker-widget-single">
                <InlineDatePicker
                  columns={1}
                  numCalendars={1}
                  showPriceDetails={true}
                  showBookButton={true}
                />
              </Portal>
              <Portal container="mobile-reservation-flow">
                <MobileReservationFlow />
              </Portal>
            </DatepickerAppContainer>
          </Portal>

          <Portal container="roi-calculator">
            <RoiCalculator />
          </Portal>

          <Portal container="group-buy-banner-escapist">
            <GroupBuyBanner model="escapist" showImages={false} />
          </Portal>

          <Portal container="group-buy-banner-nomad">
            <GroupBuyBanner model="nomad" showImages={false} />
          </Portal>

          <Portal container="group-buy-banner-escapist-with-images">
            <GroupBuyBanner model="escapist" showImages={true} />
          </Portal>

          <Portal container="group-buy-banner-nomad-with-images">
            <GroupBuyBanner model="nomad" showImages={true} />
          </Portal>

          <Portal container="user-buttons">
            <UserButtons />
          </Portal>

          <Portal container="user-buttons-mobile">
            <UserButtons layout="mobile" />
          </Portal>
        </MantineProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}

export default App;
